<template>
  <div class="legacy-check-editor">
    <div v-if="redirecting" class="state-msg">Opening Check Lab…</div>
    <CheckLabDefinitionPanel
      v-else-if="definitionId"
      :definition-id="definitionId"
      @saved="() => {}"
    />
    <div v-else class="purpose-empty">
      <div class="purpose-icon" aria-hidden="true">
        <i class="fas fa-flask"></i>
      </div>
      <h1>Check settings live in Check Lab</h1>
      <p>
        Open a project, then <strong>Check Lab → This check</strong> to name the check,
        set column cell policy, and manage rules. That surface knows which project’s
        check you are changing.
      </p>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import CheckLabDefinitionPanel from '@/components/comprehensive/CheckLabDefinitionPanel.vue';

const route = useRoute();
const router = useRouter();
const redirecting = ref(false);

const definitionId = computed(() => route.query.id || route.params.id || null);

onMounted(() => {
  const fromProject = route.query.fromProject;
  if (fromProject) {
    redirecting.value = true;
    router.replace({
      path: `/projects/${fromProject}/lab`,
      query: { tab: 'check' },
    });
  }
});
</script>

<style scoped>
.legacy-check-editor {
  min-height: calc(100vh - 3.5rem);
  background: #f8fafc;
}

.state-msg {
  padding: 2rem;
  color: #64748b;
}

.purpose-empty {
  max-width: 36rem;
  margin: 4rem auto;
  padding: 1.5rem;
  text-align: left;
}

.purpose-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 0.55rem;
  background: #f1f5f9;
  color: #334155;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.75rem;
}

.purpose-empty h1 {
  font-size: 1.25rem;
  margin: 0 0 0.5rem;
}

.purpose-empty p {
  margin: 0;
  color: #475569;
  line-height: 1.5;
}
</style>
